export default "__VITE_ASSET__BkgNS83b__"